// import Swiper from 'swiper';
// import 'remodal';

// ナビゲーションアニメーション;
// const funcNav = () => {
// 	const myMain = document.querySelectorAll('.area');
// 	const navItems = document.querySelectorAll('.side nav li');

// 	if (myMain.length === 0 || navItems.length === 0) {
// 		return;
// 	}

// 	const mainArray = Array.from(myMain);
// 	const observeAction = (entries) => {
// 		entries.forEach((entry) => {
// 			const index = mainArray.indexOf(entry.target);
// 			if (index === -1) return;

// 			if (entry.isIntersecting) {
// 				// すべてのnavItemsからactiveを削除
// 				navItems.forEach((item) => item.classList.remove('active'));
// 				// 現在の要素に対応するnavItemにactiveを追加
// 				if (navItems[index]) {
// 					navItems[index].classList.add('active');
// 				}
// 			} else {
// 				if (navItems[index]) {
// 					navItems[index].classList.remove('active');
// 				}
// 			}
// 		});
// 	};

// 	const options = {
// 		rootMargin: '0px 0px -90% 0px',
// 		threshold: 0,
// 	};

// 	const observer = new IntersectionObserver(observeAction, options);

// 	myMain.forEach((target) => {
// 		observer.observe(target);
// 	});
// };

// スクロールアニメーション;
const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');

	if (progressItems.length === 0) {
		return;
	}

	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		observer.observe(target);
	});
};

// スムーススクロール
const Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	const smoothScrollTriggers = document.querySelectorAll('.anchor');
	const myMain = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	const mainArray = Array.from(myMain);

	smoothScrollTriggers.forEach((smoothScrollTrigger) => {
		smoothScrollTrigger.addEventListener('click', (e) => {
			const href = smoothScrollTrigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 0;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * Ease.easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);

					// funcNav等要素を取る時（発火位置調整）
					// setTimeout(() => {
					// 	const index = mainArray.indexOf(targetElement);
					// 	if (index !== -1 && navItems[index]) {
					// 		navItems.forEach((item) => item.classList.remove('active'));
					// 		navItems[index].classList.add('active');
					// 	}
					// }, 100); // IntersectionObserverの更新を待つ
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// スクロールアニメーション;
	funcAnim();

	// ナビゲーションアニメーション;
	// funcNav();
});

// window.addEventListener('load', () => {
// 	// スライダー
// 	const slides = document.querySelectorAll('.slide');
// 	slides.forEach((slide) => {
// 		const swiper = slide.querySelector('.swiper-container');
// 		if (!swiper) return;
// 		const pagination = slide.querySelector('.swiper-pagination');
// 		const nextButton = slide.querySelector('.swiper-button-next');
// 		const prevButton = slide.querySelector('.swiper-button-prev');
// 		new Swiper(swiper, {
// 			loop: true,
// 			// watchOverflow: true, // loopと併用不可
// 			speed: 400,
// 			spaceBetween: 20,
// 			// autoplay: {
// 			// 	delay: 3000,
// 			// 	disableOnInteraction: false,
// 			// 	waitForTransition: false,
// 			// },
// 			// pagination: {
// 			// 	el: pagination,
// 			// 	type: 'bullets',
// 			// 	// type: 'progressbar',
// 			// 	// type: 'fraction',
// 			// 	clickable: true,
// 			// },
// 			navigation: {
// 				nextEl: nextButton,
// 				prevEl: prevButton,
// 			},
// 		});
// 	});
// });
